
import { User } from "../../interfaces/User"; // Assuming User interface is needed for some future context or consistency
import { WikiPage, NewWikiPageRequest, UpdateWikiPageRequest, WikiPageSearchResult } from "../../interfaces/wiki/Wiki";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Function to create a new wiki page
export async function createWikiPage(
  authToken: string,
  spaceId: string,
  newPage: NewWikiPageRequest
): Promise<WikiPage | null> {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/wiki/pages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(newPage),
    });

    if (!response.ok) {
      console.error(`Failed to create wiki page:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating wiki page:", error);
    return null;
  }
}

// Function to retrieve a wiki page by its ID
export async function getWikiPageById(
  authToken: string,
  pageId: string
): Promise<WikiPage | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/pages/${pageId}`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Failed to fetch wiki page ${pageId}:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching wiki page ${pageId}:`, error);
    return null;
  }
}

// Function to update an existing wiki page
export async function updateWikiPage(
  authToken: string,
  pageId: string,
  updates: UpdateWikiPageRequest
): Promise<WikiPage | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/wiki/pages/${pageId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(updates),
    });

    if (!response.ok) {
      console.error(`Failed to update wiki page ${pageId}:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`Error updating wiki page ${pageId}:`, error);
    return null;
  }
}

// Function to search for wiki pages
export async function searchWikiPages(
  authToken: string,
  query: string
): Promise<WikiPageSearchResult[] | null> {
  const queryParams = new URLSearchParams();
  queryParams.append('q', query);

  try {
    const response = await fetch(`${API_BASE_URL}/wiki/pages/search?${queryParams.toString()}`, {
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      console.error(`Failed to search wiki pages:`, response.status, response.statusText);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error(`Error searching wiki pages:`, error);
    return null;
  }
}
